import jsxElem, { render } from "jsx-no-react";
import { storeCampaigns } from "@Stores";

const listTypes = [
    {name:"Contest", key:"contest", img:"contest.svg"},
    {name:"Giveaway", key:"giveaway", img:"giveaway.svg"},
    {name:"Referral Contest", key:"referral-contest", img:"referral-contest.svg"},
    {name:"Early Access", key:"early-access", img:"early-access.svg"},
    {name:"Refer a Friend", key:"refer-a-friend", img:"refer-friend.svg"},
    {name:"Traffic", key:"traffic", img:"traffic.svg"},
];

const Type = props => (
    <a href="javascript:void(0);" class="dropdown-item filter-campaign-type" data-type={props.key} data-name={props.name}>
        <img src={`/public/images/icons/${props.img}`} alt={props.name} width="24" height="24" /> {props.name}
    </a>
);

const TypeSwitchHTML = () => (
    <>
        { listTypes.map((type => <Type name={type.name} key={type.key} img={type.img} />)) }
        <div class="dropdown-divider"></div>
        <Type name="All Campaigns" key="all" img="all-campaigns.svg" />
    </>
);

const CampaignSwitchHTML = () => {
    const list = storeCampaigns.fetch("list"), 
    LocationOrigin = (location.href).replace(`${location.origin}/`, '').split('/'),
    LocationURL = LocationOrigin[0];
    
    //sorting by name
    if(list.count!==0) {
        list.data.sort((a, b) => {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
        });
    }
    const Item = ( props ) => (
        <a href="javascript:void(0);" class="dropdown-item bmux-switch-campaign link" data-link = { `/${props.page}/redirect/${props.id}` }  data-type={ props.type } data-camp={props.id} data-name={props.name}>
            <img src={ props.icon } alt={ props.name } class="me-1" width="24" height="24" /> { props.name }
        </a>
    );
    const Items = ({data}) => data.map((item) => <Item page={LocationURL} name={htmlDecode(item.name)} icon={item.icon} id={item.id} type={item.type}/>);
    return (
        <>
            <Items data={list.data}/>
        </>
    );
};
  
const GlobalFilter = (props = {}) => {
    if(props?.show == false) {
        $(".bmui-global-filter").html("");
        return false;
    } 
    const element = props.dash ? <TypeSwitchHTML /> : <CampaignSwitchHTML />;
    render(element, document.getElementById("bmux-global-filter"));
};

const PageTitle = ( props ) => document.getElementById("bmux-page-title").innerHTML = props.title

const HelpElements = ({props}) => {
    const VideoLink = ({link}) => {
        if (link != undefined ) {
            return (
                <a class="dropdown-item" href={link} target="_blank">
                    <i class="mdi mdi-play-circle-outline font-size-16 align-middle me-1"></i> 
                    View Guide
                </a>
            );
        }
    };

    const DocumentoLink = ({ link }) => {
        if (link != undefined ) {
            return (
                <a class="dropdown-item" href={ link } target="_blank">
                    <i class="mdi mdi-file-document-outline font-size-16 align-middle me-1"></i> 
                    Documentation
                </a>
            );
        }
    };

    if( props.video != undefined || props.document != undefined) {
        return (
            <div class="dropdown d-inline-block">
                <button type="button" class="btn header-item "  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                </button>
                <div class="dropdown-menu dropdown-menu-end">
                    <VideoLink link = { props.video } />
                    <DocumentoLink link = { props.document } />
                </div>
            </div>            
        );
    }
};

const Help = ( props ) => render(<HelpElements props = { props } />, document.getElementById("bmux-help-docs"))

const InlineHelp = ( props ) => (
    <p class="card-title-desc mb-3"> 
        <span class="fas fa-info-circle text-default"></span> { props.helpText }
        <a href = { props.helpLink } class="card-link" target="_blank">Documentation</a>
    </p>    
);

const dtTextWithInitials = (txt, d) => {
    if (!txt || txt === null || txt === undefined) {
        return '-';
    }
    let firstLetter = txt.charAt(0),
    sno = parseInt(d.row % 5);
    if(firstLetter == '') {
        return '-';
    }
    return  `<span class="bmui-name-initial name_${sno}">${firstLetter}</span><strong>${txt}</strong>`;
};

export {
    GlobalFilter,
    PageTitle,
    Help,
    InlineHelp,
    dtTextWithInitials
};